<template>
  <div>
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-clipboard"></i>
          Report
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">Main</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Report</a>
          </li>
      </ul>
    </div>
    <div v-show="loading" style="z-index:100; background-color: white; opacity:1; width:100%; height:2000px; overflow:hidden; text-align:center;">
        <p style="margin-top: 500px; z-index:1001; opacity:0.6;">
          <i class="fa fa-refresh fa-spin"></i>
        </p>
    </div>
    <div v-show="!loading" id="app" class="animated fadeIn fadeOut"  style="max-width: 55rem; background-color: rgba( 255, 255, 255, 1 ); margin:0px auto;">
      <!-- <div id="app_2">
        <StepProgress active-color="skyblue" :steps="steps['EN']" :current-step="status.step"/>
      </div> -->
      <div id="app1">
        <b-row class="text-center">
          <b-col class="mt-5">
            <h3 style="margin-top:10px; color:red;" id="doc_type">[CONFIDENTIALITY]</h3><br>
          </b-col>
        </b-row>
        <hr>
        <div class="mt-5 text-center">
          <div>
            <b-row style="padding-left:25px; padding-right:20px;" class="text-center">
              <b-col>
                <h1 style="color:#3D63BA;">
                  <b id="doc_report_short_title" v-if="is_f1security_slogan()">F1-UWSS</b>
                  <b id="doc_report_short_title" v-else>{{custom.slogan.toUpperCase()}}</b>
                  <b>
                    <span id="doc_report_full_title" v-if="is_wc && !is_wsf && !is_wmds && !is_wf" style="color:#829DD4;">WEBCastle</span>
                    <span id="doc_report_full_title" v-else-if="!is_wc && is_wsf && !is_wmds && !is_wf" style="color:#829DD4;">WSFinder</span>
                    <span id="doc_report_full_title" v-else-if="!is_wc && !is_wsf && is_wmds && !is_wf" style="color:#829DD4;">WMDS</span>
                    <span id="doc_report_full_title" v-else-if="!is_wc && !is_wsf && !is_wmds && is_wf" style="color:#829DD4;">WFDetector</span>
                    <span id="doc_report_full_title" v-else-if="!is_wc && !is_wsf && !is_wmds && !is_wf" style="color:#829DD4;">{{is_f1security_slogan() ? 'Unified Web Security Service' : ''}}</span>
                    <span id="doc_report_full_title" v-else style="color:#829DD4;">{{is_f1security_slogan() ? 'Unified Web Security Service' : ''}}</span>
                  </b>
                  <!-- <b>
                    <span id="doc_report_full_title" style="color:#829DD4;">{{is_f1security_slogan() || !custom.slogan ? ':Unified Web Security Service' : ''}}</span>
                  </b> -->
                  </h1>
                <h2 v-if="!is_report_custom" class="mt-1"><b id="doc_date_monthly">Monthly Report</b></h2>
              </b-col>
            </b-row>
          </div>
        </div>
        <hr>
        <b-row class="mt-5 text-center">
          <b-col>
            <h4 class="pt-2"><b id="doc_username">{{auth.profile.username}}</b></h4>
          </b-col>
        </b-row>
        <hr>
        <b-row class="text-center mt-2">
        <!-- custom area -->
          <center style="width:100%;">
            <p>* This area does not display when exporting</p>
            <VueHotelDatepicker style="margin: 0 10px;" v-if="is_report_custom" block :format="'YYYY-MM-DD'" :minDate="minDate" :maxDate="maxDate" @confirm="confirm_custom"/>
            <v-select style="margin: 0 10px; width: 150px; display:inline-block;" v-if="!is_report_custom" :readonly="true" v-model="opt.year" :options="years" ></v-select>
            <span style="margin: 0 10px;" v-if="!is_report_custom">/</span>
            <v-select value="$store.myValue" style="margin: 0 10px; width: 150px; display:inline-block;" v-if="!is_report_custom" :readonly="true" label="text" v-model="opt.month" :options="codes.REPORT_MONTH_ENG" ></v-select>
            <b-form-checkbox style="display:inline-block;" v-model="is_report_custom"> Select Date </b-form-checkbox>
            <b-btn style="margin:0 20px;" @click="makePDF()" variant="outline-success">Export PDF</b-btn>
            <hr style="width:50%;">
            <b-form-checkbox :disabled="!auth.license.WEBCastle.use" style="display:inline-block; padding-right:10px;" v-model="is_wc"> WEBCastle </b-form-checkbox>
            <b-form-checkbox :disabled="!auth.license.WSFinder.use" style="display:inline-block; padding-right:10px;" v-model="is_wsf"> WSFinder </b-form-checkbox>
            <b-form-checkbox :disabled="!auth.license.WMDS.use" style="display:inline-block; padding-right:10px;" v-model="is_wmds"> WMDS </b-form-checkbox>
            <b-form-checkbox :disabled="!auth.license.WFDetect.use" style="display:inline-block;" v-model="is_wf"> WFDetecter </b-form-checkbox>
          </center>
        </b-row>
        <!-- 도메인별 보고서용 -->
        <hr v-if="auth.license.WEBCastle.use && is_wc && !is_wsf && !is_wmds && !is_wf">
        <b-row class="text-center" v-if="auth.license.WEBCastle.use && is_wc && !is_wsf && !is_wmds && !is_wf">
          <b-col sm="2">
          </b-col>
          <b-col sm="4">
            <p>1. Server</p>
            <!-- @select="() => getDomainList()" -->
            <multiselect
              @input="getDomainList()"
              v-model="agent"
              tag-placeholder="Select Server"
              placeholder="Select Server"
              label="nickname"
              track-by="nickname"
              :options="agent_list"
              :multiple="true"
              :taggable="true"
              @tag="add_tag">
            </multiselect>
          </b-col>
          <b-col sm="4">
            <p>2. Domain</p>
            <multiselect
              @input="domain_reload()"
              v-model="domain"
              tag-placeholder="Select domain"
              placeholder="Select domain"
              :options="domain_list"
              :multiple="true"
              :taggable="true"
              :disabled="!agent.length || !domain_list.length || domain_loading"
              @tag="add_tag">
            </multiselect>
          </b-col>
        </b-row>
        </div>
    </div>
</div>
</template>
<style>
  .table-f1 {
    border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; padding: 0px 5px;
  }
  .border-bg-f1 {
    border:1px solid; background-Color:#f0f3f5; color:#000000;  text-align: center;
  }
  .border-f1 {
    border:1px solid; color:#000000;  text-align: center;
  }
  .border-text-f1 {
    border:1px solid; text-align: center !important;
  }
  #app1 {
    height: 950px;
  }
</style>
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
